<template>
  <div>
    
    <div class="page" ref="page">
      
      <canvas ref="signHandle" class="canvas" />
      <div class="btn_container van-hairline--top">
        <van-button class="button" size="normal" @click="clearHandle"
          >清空签名</van-button
        >
        <van-button
          class="button button-right"
          size="normal"
          type="info"
          @click="onComfirm"
          >确认签名</van-button
        >
      </div>
    </div>
    <!-- <h1 class="h1_title">确认签字</h1>
    <div class="tishi">本人已阅读全部开户文件井确认上述资料真实有效</div> -->
  </div>
</template>

<script>
// 解构设备的宽度, 和 高度
import Vue from 'vue'
import { Button, Toast } from 'vant'
Vue.use(Button).use(Toast)
export default {
  name: 'account_signature',
  data () {
    return {
      token: '',
      radio: '#000',
      height: 50,
      direction: true, // true 代表横屏, false 代表'竖屏' -- 但是亲测没有效果
      el: '', // canvas dom
      ctx: '', // canvas context
      background: '#fff', // canvas background-color
      color: '#000', // 绘制时线条的颜色
      linewidth: 3, // 线条的宽度
      liColors: ['#000'],
      drawCheck: false, //用来判断是否签字
      clientHeight: document.documentElement.clientHeight,
      clientWidth: document.documentElement.clientWidth,
      // clientHeight: 300,
      // clientWidth: 375,
      formItem:{
        signature_pic:''
      }
    }
  },
  mounted () {
    window.onresize = () => {
      this.clientHeight = document.documentElement.clientHeight
      this.clientWidth = document.documentElement.clientWidth
      this.draw()
      return
    }
    if (this.$route.query.token == "" || this.$route.query.token == undefined) {
      this.$router.replace('/nologin')
    } else {
      this.token = this.$route.query.token
      this.draw()
    }
    
  },
  methods: {
    // 添加绘制 line
    draw () {
      this.$refs.signHandle.addEventListener(
        'touchstart',
        e => e.preventDefault(),
        {
          passive: false
        }
      )
      this.el = this.$refs.signHandle
      this.initCanvas()
    },
    // 初始化canvas配置
    initCanvas () {
      const {el } = this
      el.width = this.clientWidth
      el.height = this.clientHeight - 50
      this.ctx = el.getContext('2d')
      this.setCanvas()
      this.drawStart()
      this.drawing()
      this.drawEnd()
    },
    // 配置 canvas
    setCanvas () {
      const { ctx, direction } = this
      console.log(direction)
      // 设置背景色
      ctx.fillStyle = this.background
      ctx.fillRect(0, 0, this.clientWidth, this.clientHeight - 50)
      // 设置线条颜色
      ctx.strokeStyle = this.color
      // 设置线宽
      ctx.lineWidth = this.linewidth
      // 设置线条两头的结束点和开始点是圆形的
      ctx.lineCap = 'round'
    },
    // 开始绘制
    drawStart () {
      const { el, ctx } = this
      el.addEventListener(
        'touchstart',
        e => {
          ctx.beginPath()
          ctx.moveTo(e.changedTouches[0].pageX, e.changedTouches[0].pageY)
          this.drawCheck = true //代表签过字
        },
        false
      )
    },
    // 绘制中
    drawing () {
      const { el, ctx } = this
      el.addEventListener(
        'touchmove',
        e => {
          ctx.lineTo(e.changedTouches[0].pageX, e.changedTouches[0].pageY)
          ctx.stroke()
        },
        false
      )
    },
    // 绘制结束
    drawEnd () {
      const { el, ctx } = this
      el.addEventListener('touchend', () => ctx.closePath(), false)
    },
    // 清空
    clearHandle () {
      console.log('清空')
      this.initCanvas()
      this.drawCheck = false //代表签过字
    },
    onComfirm () {
      if (this.drawCheck == false) {
        Toast.fail('请确保已经签字')
        return
      }
      this.saveImg()
      // this.adminSave()
    },
    // 保存信息
    saveImg () {
      let file=this.dataURLtoFile(this.el.toDataURL(),'1.png')
      const formData = new FormData();
      console.log(file)
      formData.append('file_ext', '.png')
      formData.append('file', file)
      this.$axios({
        method: 'post',
        url: 'Image/upload',
        data: formData
      }).then ((res) => {
        if (res.status) {
          this.formItem.signature_pic = res.source
          this.nextStep()
        }else{
          this.$toast.fail('上传失败')
        }
      })
    },
    nextStep() {
      this.$axios({
        method: 'post',
        url: 'account_open/alter',
        data: {
          token: this.token,
          signature_pic: this.formItem.signature_pic
        }
      }).then ((res) => {
        if (res.success) {
          // this.$router.push('/account/type?token=' + this.token)
          this.$router.push('/account/success')
        }else{
          this.$toast.fail(res.error_text)
        }
      })
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
      while(n--){
          u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {type:mime});
    }
  }
}
</script>

<style scoped>
/* .page {
  height: 50vh;
  width: 100vw;
  
} */
.tishi{
    background: white;
    padding: 20px 10px;
  }
  .btn_container {
    width: 100%;
    background-color: #fff;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    justify-content: space-between;

    
  }
  .btn_container .button {
    width: 50%;
  }

  .btn_container .button-right {
    margin-left: 4px;
  }

.button-wrapper {
  min-width: 180px;
  display: flex;
  justify-content: space-between;
}
</style>
